import { ClientMode, Command } from 'types/command'
import { setupBaseUrl } from 'utils/setupBaseUrl'
import logError from 'utils/logError'

const execQueueItem = async (command: Command) => {
  setupBaseUrl(command.baseUrl)

  if (command.mode === ClientMode.Manager) {
    const { default: mountManager } = await import(
      /* webpackChunkName: "Manager" */
      'containers/Manager/Manager.mount'
    )
    mountManager(command)
  } else {
    logError(
      new Error(
        `Unknown erx client mode: ${JSON.stringify(
          (command as { mode: string }).mode
        )}`
      )
    )
  }
}

const main = async () => {
  window._erxClient = window._erxClient || []
  if (window.MOCK_DATA) {
    await import(
      /* webpackChunkName: "InitMock" */
      'init-mock'
    )
  }
  window._erxClient.forEach(execQueueItem)
  window._erxClient = {
    push: execQueueItem,
    forEach() {}
  }
}

void main()
